module.exports = __webpack_public_path__ + "bg-card-2.jpg";